import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import { PasswordStrength } from '../PasswordStrength';
import { PrimaryButton } from '../PrimaryButton';
import { BuildingUserActions } from '../../store';
import { Notification } from '../Notification';
import { Spinner } from '../Spinner';
import './NewUser.css';

const logo = require('./assets/logo.png');

export class NewUser extends Component {
  state = {
    page: 1,
    firstName: '',
    lastName: '',
    phoneNumber: '',
    password1: '',
    password2: '',
    validationErrors: '',
  };

  componentDidMount() {
    const { validateInviteToken } = this.props;
    const { token } = this.props.match.params;

    validateInviteToken(token);
  }

  onTextFieldChange = (e) => {
    const { name, value } = e.currentTarget;

    this.setState((state) => ({
      ...state,
      [name]: value,
    }));
  };

  onPhoneNumberChange = (dialCode, phoneNumber) => {
    const formattedPhoneNumber = `+${dialCode}${phoneNumber}`;

    this.setState((state) => ({
      ...state,
      phoneNumber: formattedPhoneNumber,
    }));
  };

  nextPage = () => {
    const { firstName, lastName, phoneNumber } = this.state;

    if (!firstName || !lastName || !phoneNumber) {
      this.setState((state) => ({
        ...state,
        validationErrors: 'Fields cannot be blank',
      }));
    } else {
      this.setState((state) => ({
        ...state,
        page: 2,
        validationErrors: '',
      }));
    }
  };

  acceptNewUserInvite = () => {
    const { firstName, lastName, phoneNumber, password1, password2 } = this.state;
    const {
      validInviteInformation: { api_location: apiLocation, email },
      acceptNewUserInvite,
    } = this.props;

    if (password1 !== password2) {
      return this.setState((state) => ({
        ...state,
        validationErrors: 'Passwords must match',
      }));
    }

    acceptNewUserInvite(apiLocation, firstName, lastName, email, phoneNumber, password1, password2);
    this.setState((state) => ({
      ...state,
      validationErrors: '',
    }));
  };

  acceptInvite = () => {
    const {
      validInviteInformation: { api_location: apiLocation, email },
      acceptInvite,
    } = this.props;

    acceptInvite(apiLocation, email);
    this.setState((state) => ({
      ...state,
      validationErrors: '',
    }));
  };

  renderSetPassword() {
    const { password1, password2, validationErrors } = this.state;

    return (
      <div className="new-user-fields-wrapper">
        <div className="new-user-fields">
          <div className="new-user__text">Please set the password for your account:</div>
          <div className="new-user-form">
            <div className="new-user__input-wrapper">
              <input
                value={password1}
                className="new-user__text-input"
                id="password1"
                name="password1"
                type="password"
                placeholder="Enter password"
                onChange={this.onTextFieldChange}
              />
            </div>
            <PasswordStrength password={password1} />
            <div className="new-user__input-wrapper">
              <input
                value={password2}
                className="new-user__text-input"
                id="password2"
                name="password2"
                type="password"
                placeholder="Re-Enter password"
                onChange={this.onTextFieldChange}
              />
            </div>
            {validationErrors && <div className="new-user__error-message">{validationErrors}</div>}
            <div className="new-user__button">
              <PrimaryButton
                label="Register"
                onClick={this.acceptNewUserInvite}
                fullWidth={true}
                isDisabled={!password1 || !password2}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderSetAccountInformation() {
    const { firstName, lastName, validationErrors } = this.state;
    const {
      validInviteInformation: { email },
    } = this.props;

    return (
      <div className="new-user-fields-wrapper">
        <div className="new-user-fields">
          <div className="new-user__text">Please fill in your information</div>
          <div className="new-user-form">
            <div className="new-user__input-wrapper">
              <input
                value={firstName}
                className="new-user__text-input"
                id="firstName"
                name="firstName"
                placeholder="First Name"
                onChange={this.onTextFieldChange}
              />
            </div>
            <div className="new-user__input-wrapper">
              <input
                className="new-user__text-input"
                value={lastName}
                id="lastName"
                name="lastName"
                placeholder="Last Name"
                onChange={this.onTextFieldChange}
              />
            </div>
            <div className="new-user__input-wrapper">
              <input className="new-user__text-input read-only" value={email} id="email" name="email" readOnly={true} />
            </div>
            <div className="new-user__input-wrapper">
              <IntlTelInput
                className="new-user__text-input"
                onPhoneNumberChange={(status, value, countryData, number, id) => {
                  this.onPhoneNumberChange(countryData.dialCode, value);
                }}
                id="phoneNumber"
                name="phoneNumber"
                autoFocus={false}
                format={false}
                defaultCountry="ca"
                inputClassName="new-user__phone-input"
              />
            </div>
            {validationErrors && <div className="new-user__error-message">{validationErrors}</div>}
            <div className="new-user__button">
              <PrimaryButton label="Next" onClick={this.nextPage} fullWidth={true} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { validateTokenError, inviteAccepted, validInviteInformation } = this.props;
    const { page } = this.state;

    if (validateTokenError) {
      return (
        <div className="new-user">
          <div className="new-user-content">
            <div className="new-user-logo-wrapper">
              <img className="new-user__logo" src={logo} alt="Parity" />
            </div>
            <div className="new-user-notification-content">
              <div className="new-user-notification-wrapper">
                <Notification message={validateTokenError} type="error" />
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (inviteAccepted) {
      return (
        <div className="new-user">
          <div className="new-user-content">
            <div className="new-user-logo-wrapper">
              <img className="new-user__logo" src={logo} alt="Parity" />
            </div>
            <div className="new-user-notification-content">
              <div className="new-user-notification-wrapper">
                <Notification title="Success!" message="Your access was granted." type="success" />
                <Link to="/login" className="new-user__login-link">
                  Click here to login
                </Link>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (validInviteInformation && validInviteInformation.is_existing_user) {
      return (
        <div className="new-user">
          <div className="new-user-content">
            <div className="new-user-logo-wrapper">
              <img className="new-user__logo" src={logo} alt="Parity" />
            </div>
            <div className="new-user-notification-content">
              <div className="new-user-notification-wrapper">
                <Notification message="Click here to accept your invite." type="info" />
                <div className="new-user-accept-button">
                  <PrimaryButton label="Accept invite" onClick={this.acceptInvite} />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="new-user">
        <div className="new-user-content">
          <div className="new-user-logo-wrapper">
            <img className="new-user__logo" src={logo} alt="Parity" />
          </div>
          {!validInviteInformation ? (
            <div className="new-user-notification-content">
              <Spinner />
            </div>
          ) : (
            <React.Fragment>
              {page === 1 ? this.renderSetAccountInformation() : this.renderSetPassword()}
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

NewUser.propTypes = {
  validInviteInformation: PropTypes.shape({
    email: PropTypes.string,
    is_valid: PropTypes.bool,
    is_accepted: PropTypes.bool,
    api_location: PropTypes.string,
    is_existing_user: PropTypes.bool,
  }),
  match: PropTypes.shape({
    path: PropTypes.string,
    url: PropTypes.string,
    isExact: PropTypes.bool,
    params: PropTypes.shape({
      token: PropTypes.string,
    }),
  }).isRequired,
  validateInviteToken: PropTypes.func,
  acceptNewUserInvite: PropTypes.func,
};

NewUser.defaultProps = {
  validInviteInformation: undefined,
};

export function mapStateToProps(state) {
  return {
    validInviteInformation: state.buildingUserReducer.validInviteInformation,
    validateTokenError: state.buildingUserReducer.error,
    inviteAccepted: state.buildingUserReducer.inviteAccepted,
  };
}

const mapDispatchToProps = {
  validateInviteToken: BuildingUserActions.validateUserInvite,
  acceptNewUserInvite: BuildingUserActions.acceptNewUserInvite,
  acceptInvite: BuildingUserActions.acceptInvite,
};

export const ConnectedNewUser = connect(mapStateToProps, mapDispatchToProps)(NewUser);
